import { apiFetch } from './client';
import type { ActivityLogEntry, AdminUser, LoginEvent, Paginated, Vertical } from '$lib/types';

function toQuery(params: Record<string, string | number | undefined> = {}): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') search.set(key, String(value));
  }
  const s = search.toString();
  return s ? `?${s}` : '';
}

export const adminUsersApi = {
  list: (params?: { q?: string; page?: number; per_page?: number }) =>
    apiFetch<Paginated<AdminUser>>(`/admin/users${toQuery(params)}`),
  create: (body: Record<string, unknown>) =>
    apiFetch<AdminUser>('/admin/users', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: Record<string, unknown>) =>
    apiFetch<AdminUser>(`/admin/users/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/admin/users/${id}`, { method: 'DELETE' }),
  resetTotp: (id: number) =>
    apiFetch<{ detail: string }>(`/admin/users/${id}/reset-totp`, { method: 'POST' }),
  resetPassword: (id: number) =>
    apiFetch<{ detail: string; temp_password: string }>(`/admin/users/${id}/reset-password`, {
      method: 'POST'
    })
};

export const adminLoginsApi = {
  forUser: (id: number, params?: { page?: number; per_page?: number }) =>
    apiFetch<Paginated<LoginEvent>>(`/admin/users/${id}/logins${toQuery(params)}`),
  recent: (params?: { limit?: number }) =>
    apiFetch<{ results: LoginEvent[] }>(`/admin/logins${toQuery(params)}`)
};

export const adminActivityApi = {
  list: () => apiFetch<{ results: ActivityLogEntry[]; count: number }>('/admin/activity')
};

export const adminVerticalsApi = {
  list: () => apiFetch<{ results: Vertical[]; count: number }>('/admin/verticals'),
  create: (body: Record<string, unknown>) =>
    apiFetch<Vertical>('/admin/verticals', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: Record<string, unknown>) =>
    apiFetch<Vertical>(`/admin/verticals/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  remove: (id: number) =>
    apiFetch<{ detail: string }>(`/admin/verticals/${id}`, { method: 'DELETE' })
};
